import React from "react";

const Statistics = () => {
  return (
    <div className="text-3xl flex items-center justify-center  w-full mt-[-60px] font-semibold text-gray-600">
      <h1> Statistics will coming soon 😊</h1>
    </div>
  );
};

export default Statistics;
